var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowOpenBleu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 46,
    viewBox: "0 0 39 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.870361,
    y: 0.833008,
    width: 37.7871,
    height: 44.7918,
    rx: 10,
    fill: "#5387FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.51807,
    y: 11.3752,
    width: 20.4318,
    height: 24.2192,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_300_20927",
    transform: "translate(-0.0926859) scale(0.0493905 0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_300_20927",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDcuMS1jMDAwIDc5LmRhYmFjYmIsIDIwMjEvMDQvMTQtMDA6Mzk6NDQgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMi41IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkJFODU5MDczNkE0NzExRURBMzVDQjk4RDg1MjU4MTk2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkJFODU5MDc0NkE0NzExRURBMzVDQjk4RDg1MjU4MTk2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QkU4NTkwNzE2QTQ3MTFFREEzNUNCOThEODUyNTgxOTYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QkU4NTkwNzI2QTQ3MTFFREEzNUNCOThEODUyNTgxOTYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6rwRQ2AAABcElEQVR42uyVTStEURjH73C9zixESNSEIS97dHc+gHwAJSsbJStLki8wWYmULC1m5yvMxuZuUAorYcZ0ZyHvXL9H/8UtG4t7pTj16/zPOc95nnue7jlPKgzDFcdxFqHGibe9wU6KALeILmiADi32QAqeoKS5NLRKl+FR2va68ALXmrvR3rIt1EIdHMtZMwzKoBGO4Bn6oEkOHuAc6mFUwewDT+FeHzr0ackJAsiCDzb24ED6EHLSBZgUBc3lZONojyfty2cQd96/tP8AfyCAG7lEWdiHNv3L1t5hA+5gTGNH2mwzkTnr16EiX+logBZdsC2NL9TPQbf0JhSlZyOnv1S/BL3S0/L5cymqKi3zkRRNwa6ObCnyYEb2ezpNRvbjkFcWKtpf/bVPRQBXSf6mPiwkGaAf1pIMcAarSQYYgOUkA1g5nfiusdXkQLf1RLU2jpLZDsN2y11Vf3MwAp0xFf2Sxq+2sB1xEmezxy//IcAADnr9fCjZvfkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowOpenBleu);
export default __webpack_public_path__ + "static/media/window-open-bleu.2794744bca872fbe635bf69a114056d4.svg";
export { ForwardRef as ReactComponent };